var plants_admin_url = "";
var plants_per_page = "";
var plants_paged = 1;
var plants_height = "";
var plants_exposure = "";
var plants_bloom_time = "";
var plants_flower_color = "";
var plants_wildlife_interest = "";
jQuery(document).ready(function ($) {

    jQuery("a[href='#']").attr("href", "javascript:void(0)");

    jQuery('select').selectric({
        openOnFocus: false,
        disableOnMobile: false,
        nativeOnMobile: false
    });
    jQuery(".validation_message").attr("role", "alert");
    jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
        jQuery(".validation_message").attr("role", "alert");
    });

    jQuery(document).ajaxComplete(function () {
        jQuery('select').selectric('refresh');
    });
    jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
        jQuery('select').selectric('refresh');
    });

    jQuery(".video_sec .video_poster_sec .play_btn").click(function () {
        setTimeout(function () {
            jQuery('.lity').addClass('video_sec_popup_open');
            jQuery('body').addClass('video_sec_popup_active');
        });
    });

    jQuery(document).on('lity:close', function (event, instance) {
        jQuery('.lity').removeClass('video_sec_popup_open');
        jQuery('body').removeClass('video_sec_popup_active');
    });

    jQuery(".accordion_sec").each(function (index) {
        jQuery(this).find(".accordion_list__item__inner__title").on("click", function (e) {
            e.preventDefault();
            jQuery('accordion_list__item__inner__content');
            if (jQuery(this).next().is(":visible")) {
                jQuery(this).removeClass("active");
                jQuery(this).next().slideUp();
            } else {
                jQuery(".accordion_list__item__inner__content").slideUp();
                jQuery(".accordion_list__item__inner__title").removeClass("active");
                jQuery(this).addClass("active");
                jQuery(this).next().slideDown();
            }
        });
    });

    jQuery(document).on('click', '.cta__inner .locations_we_serve_text', function () {
        jQuery(this).toggleClass('active').next().slideToggle(500);
    });


    jQuery(document).on("click", ".tag_text", function () {
        if (jQuery(window).width() < 992) {
            if (jQuery(this).next().is(":hidden")) {
                jQuery(this).next().slideDown();
            } else {
                jQuery(this).next().slideUp();
            }
        }
    });

    jQuery(document).on("click", ".tag_list__item", function () {
        if (jQuery(window).width() < 992) {
            var ddText = jQuery(this).text();
            jQuery(".gallery_list_with_sidebar_sec__inner__wrappper__sidebar__inner").text(ddText);
            jQuery(".gallery_list_with_sidebar_sec__inner__wrappper__sidebar__inner").next().slideUp();
        }
    });
    jQuery(document).on("click", ".fiter_title", function () {
        if (jQuery(window).width() < 992) {
            if (jQuery(this).next().is(":hidden")) {
                jQuery(this).next().slideDown();
            } else {
                jQuery(this).next().slideUp();
            }
        }
    });

    $(".image_slider_sec").each(function (index) {
        let slide = $(this).find('.image_slider_sec__inner__list__item');
        let slider = $(this).find('.image_slider_sec__inner__list');
        if ($(slide).length > 1) {
            $(slider).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                dots: false,
                prevArrow: $('.prev-slide'),
                nextArrow: $('.next-slide'),
            });
        }
    });


    $(".image_testimonial").each(function (index) {
        if (window.innerWidth < 992) {
            if (!$('.testimonial_scroll__inner').hasClass('slick-initialized')) {
                let slide = $(this).find('.testimonial_item');
                let slider = $(this).find('.testimonial_scroll__inner');
                if ($(slide).length > 1) {
                    $(slider).slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        arrows: true,
                        dots: false,
                        adaptiveHeight: true,
                        prevArrow: $('.prev-slide'),
                        nextArrow: $('.next-slide'),
                    });
                }
            }
        } else {
            if ($('.testimonial_scroll__inner').hasClass('slick-initialized')) {
                $('.testimonial_scroll__inner').slick('unslick');
            }
        }
    });

    $(".plant_details_sec").each(function (index) {
        let slide = $(this).find('.image_list__item');
        let slider = $(this).find('.image_list');
        if ($(slide).length > 1) {
            $(slider).slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                arrows: false,
                dots: false,
                responsive: [{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        }
    });

    equalheight('.image_content_with_button_sec .title');
    equalheight('.image_content_with_button_sec .short_content');
    equalheight('.image_title_content_sec .title ');

    if (jQuery(".plants_list_sec").length > 0) {

        jQuery(document).on("click", ".plants_list__wrapper .custom_pagination .page-item:not(.prev,.next) a", function (e) {
            e.preventDefault();
            if (!jQuery(this).parent().hasClass("active")) {
                var last = jQuery(".pagination").attr("data-total");
                var first = 1;
                jQuery(".pagination .page-item").removeClass('active');
                jQuery(this).parent().addClass("active");
                if (!isNaN(jQuery(this).text())) {
                    plants_paged = jQuery(this).text();
                    if (first == plants_paged) {
                        jQuery(".pagination li.prev").addClass("disabled");
                        jQuery(".pagination li.next").removeClass("disabled");
                    } else if (last == plants_paged) {
                        jQuery(".pagination li.prev").removeClass("disabled");
                        jQuery(".pagination li.next").addClass("disabled");
                    } else {
                        jQuery(".pagination li.prev, .pagination li.next").removeClass("disabled");
                    }
                }
                filterPlants('loadmore');
            }
        });


        jQuery(document).on("click", ".plants_list__wrapper .custom_pagination li.prev:not(.disabled) a.page-link, .plants_list__wrapper .custom_pagination li.next:not(.disabled) a.page-link", function (e) {
            e.preventDefault();
            var last = jQuery("ul.pagination").attr("data-total");
            var first = 1;
            var strcurrent = jQuery(".pagination li.active a").text();
            if (strcurrent == "") {
                strcurrent = plants_paged;
            }
            var current = 1;
            if (strcurrent != null && strcurrent != undefined && strcurrent != "" && !isNaN(strcurrent)) {
                current = parseInt(strcurrent);
            }
            if (current != first && jQuery(this).parent().hasClass("prev")) {
                jQuery(".pagination .page-item.active").addClass("toremove");
                jQuery(".pagination .page-item.active").prev().addClass("active");
                jQuery(".pagination .page-item.active.toremove").removeClass("toremove active");
                jQuery(".pagination .page-item.next").removeClass("disabled");
                plants_paged--;
                if (plants_paged == first) {
                    jQuery(this).parent().addClass("disabled");
                }
                filterPlants('loadmore');
            } else if (current != last && jQuery(this).parent().hasClass("next")) {
                jQuery(".pagination .page-item.active").addClass("toremove");
                jQuery(".pagination .page-item.active").next().addClass("active");
                jQuery(".pagination .page-item.active.toremove").removeClass("toremove active");
                jQuery(".pagination .page-item.prev").removeClass("disabled");
                plants_paged++;
                if (plants_paged == last) {
                    jQuery(this).parent().addClass("disabled")
                }
                filterPlants('loadmore');
            }
        });

        jQuery("input[type=checkbox][name='plant_height']").on("change", function () {
            if (jQuery("input[type=checkbox][name='plant_height']:checked").length > 0) {
                var arrayVal = "";
                jQuery("input[type=checkbox][name='plant_height']:checked").each(function () {
                    var val1 = jQuery(this).val();
                    if (arrayVal != "") {
                        arrayVal += ",";
                    }

                    arrayVal += val1;
                })
                plants_height = arrayVal;
            } else {
                plants_height = "";
            }
            plants_paged = 1;
            filterPlants('filter');
        })
        jQuery("input[type=checkbox][name='plant_exposure']").on("change", function () {
            if (jQuery("input[type=checkbox][name='plant_exposure']:checked").length > 0) {
                var arrayVal = "";
                jQuery("input[type=checkbox][name='plant_exposure']:checked").each(function () {
                    var val1 = jQuery(this).val();
                    if (arrayVal != "") {
                        arrayVal += ",";
                    }

                    arrayVal += val1;
                })
                plants_exposure = arrayVal;
            } else {
                plants_exposure = "";
            }
            plants_paged = 1;
            filterPlants('filter');
        })
        jQuery("input[type=checkbox][name='plant_bloom_time']").on("change", function () {
            if (jQuery("input[type=checkbox][name='plant_bloom_time']:checked").length > 0) {
                var arrayVal = "";
                jQuery("input[type=checkbox][name='plant_bloom_time']:checked").each(function () {
                    var val1 = jQuery(this).val();
                    if (arrayVal != "") {
                        arrayVal += ",";
                    }

                    arrayVal += val1;
                })
                plants_bloom_time = arrayVal;
            } else {
                plants_bloom_time = "";
            }
            plants_paged = 1;
            filterPlants('filter');
        })
        jQuery("input[type=checkbox][name='plant_flower_color']").on("change", function () {
            if (jQuery("input[type=checkbox][name='plant_flower_color']:checked").length > 0) {
                var arrayVal = "";
                jQuery("input[type=checkbox][name='plant_flower_color']:checked").each(function () {
                    var val1 = jQuery(this).val();
                    if (arrayVal != "") {
                        arrayVal += ",";
                    }

                    arrayVal += val1;
                })
                plants_flower_color = arrayVal;
            } else {
                plants_flower_color = "";
            }
            plants_paged = 1;
            filterPlants('filter');
        })
        jQuery("input[type=checkbox][name='plant_wildlife_interest']").on("change", function () {
            if (jQuery("input[type=checkbox][name='plant_wildlife_interest']:checked").length > 0) {
                var arrayVal = "";
                jQuery("input[type=checkbox][name='plant_wildlife_interest']:checked").each(function () {
                    var val1 = jQuery(this).val();
                    if (arrayVal != "") {
                        arrayVal += ",";
                    }

                    arrayVal += val1;
                })
                plants_wildlife_interest = arrayVal;
            } else {
                plants_wildlife_interest = "";
            }
            plants_paged = 1;
            filterPlants('filter');
        })
    }

    $portfolio_slider_for_prev = '<div class="slick-prev"><svg width="67" height="53" viewBox="0 0 67 53" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M54.9492 26.4934L17.101 26.4934" stroke="#061918" stroke-width="2"/><path d="M30.2656 41.2087L17.101 26.4935L30.2656 11.7783" stroke="#061918" stroke-width="2"/></svg></div>';

    $portfolio_slider_for_next = '<div class="slick-next"><svg width="67" height="53" viewBox="0 0 67 53" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.0508 26.5066L49.899 26.5066" stroke="#061918" stroke-width="2"/><path d="M36.7344 11.7913L49.899 26.5065L36.7344 41.2217" stroke="#061918" stroke-width="2"/></svg></div>';


    $('.portfolio_slider_for').slick({
        slidesToShow: 1,
        arrows: true,
        asNavFor: '.portfolio_slider_nav',
        vertical: false,
        autoplay: false,
        verticalSwiping: true,
        centerMode: false,
        prevArrow: $portfolio_slider_for_prev,
        nextArrow: $portfolio_slider_for_next,
    });

    $('.portfolio_slider_nav').slick({
        slidesToShow: 5,
        asNavFor: '.portfolio_slider_for',
        vertical: true,
        focusOnSelect: true,
        infinite: true,
        autoplay: false,
        arrows: false,
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    vertical: false,
                }
            }, {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    vertical: false,
                }
            }, {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                    vertical: false,
                }
            }

        ]
    });

    // $('.gallery_list_with_sidebar_sec__inner__wrappper__list_slider').slickLightbox({
    //     src: 'src',
    //     itemSelector: '.gallery_list__item__inner__img__inner img',
    //     background: 'rgba(0, 0, 0, .7)'
    // });

    // $('.gallery_list_with_sidebar_sec__inner__wrappper__list_slider').slick({
    //     slidesToShow: 1,
    //     arrows: true,
    //     vertical: false,
    //     autoplay: false,
    //     verticalSwiping: true,
    //     centerMode: false,
    //     infinite: false,
    //     prevArrow: $portfolio_slider_for_prev,
    //     nextArrow: $portfolio_slider_for_next,
    // });

    $('.three_column_image_slider').slickLightbox({
        src: 'src',
        itemSelector: '.image_grid__item__inner img',
        background: 'rgba(0, 0, 0, .7)'
    });

    $('.three_column_image_slider').slick({
        slidesToShow: 1,
        arrows: true,
        vertical: false,
        autoplay: false,
        verticalSwiping: true,
        centerMode: false,
        infinite: false,
        prevArrow: $portfolio_slider_for_prev,
        nextArrow: $portfolio_slider_for_next,
    });

    $('.portfolio_slider_for').slickLightbox({
        src: 'src',
        itemSelector: '.js_gallery_popup img',
        background: 'rgba(0, 0, 0, .7)'
    });

    $('.gallery_post_list_sec__inner__wrappper__list_slider').slick({
        slidesToShow: 1,
        arrows: true,
        vertical: false,
        autoplay: false,
        verticalSwiping: true,
        centerMode: false,
        infinite: false,
        prevArrow: $portfolio_slider_for_prev,
        nextArrow: $portfolio_slider_for_next,
    });

    $('.plants_image_list_hidden_slider').slick({
        slidesToShow: 1,
        arrows: true,
        vertical: false,
        autoplay: false,
        verticalSwiping: true,
        centerMode: false,
        infinite: false,
        prevArrow: $portfolio_slider_for_prev,
        nextArrow: $portfolio_slider_for_next,
    });

    $('.gallery_post_list_sec__inner__wrappper__list_slider').slickLightbox({
        src: 'src',
        itemSelector: '.gallery_list__item__inner__img__inner img',
        background: 'rgba(0, 0, 0, .7)'
    });

    $(".gallery_post_list_sec__inner__wrappper__list.grid_view .gallery_list__item").on("click", function () {
        var postId = jQuery(this).attr("data-click");
        if (postId != undefined && postId != "" && postId != null) {
            $(".gallery_post_list_sec__inner__wrappper__list_slider .gallery_list__item[data-click='" + postId + "'] img").click();
        }
    })

    $(".grid_images_three_sec .image_grid .image_grid__item").on("click", function () {
        var postId = jQuery(this).attr("data-click");
        if (postId != undefined && postId != "" && postId != null) {
            $(".three_column_image_slider .image_grid__item[data-click='" + postId + "'] img").click();
        }
    })

    // $(document).on("click", ".gallery_list_with_sidebar_sec .gallery_list_with_sidebar_sec__inner__wrappper__list .gallery_list__item.withSidebar", function () {
    //     var postId = jQuery(this).attr("data-click");
    //     if (postId != undefined && postId != "" && postId != null) {
    //         $(".gallery_list_with_sidebar_sec__inner__wrappper__list_slider .gallery_list__item[data-click='" + postId + "'] img").click();
    //     }
    // })

    $('.image_list.grid_view').slickLightbox({
        src: 'src',
        itemSelector: '.image_list__item__inner img',
        background: 'rgba(0, 0, 0, .7)',
        caption: function (element, info) {
            return $(element).parent().find(".hidden_html").html();
        }
    });

    $(".plant_details_sec .image_list.grid_view .image_list__item").on("click", function () {
        var postId = jQuery(this).attr("data-click");
        if (postId != undefined && postId != "" && postId != null) {
            $(".plants_image_list_hidden_slider .image_list__item[data-click='" + postId + "'] img").click();
        }
    })

    $(document).on("click", ".slick-lightbox-close", function () {
        jQuery(".slick-lightbox").remove();
    })

    var $status = jQuery('.slider_counter_section');
    var $slickElement = jQuery('.portfolio_slider_for');
    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        $status.html('<span class="text">Photo </span><span class="current_slide">' + i + '</span><span class="text"> of </span><span class="total_slides"> ' + slick.slideCount + '</span>');
    });

    jQuery(".featured_list_sec__inner .tag_list__item .tag_list__item_link").on("mouseover", function () {
        var hoverId = jQuery(this).attr("data-hover");
        if (hoverId != undefined && hoverId != "" && hoverId != null && jQuery("#" + hoverId).length > 0) {
            jQuery(".featured_list__item_image__inner .image").removeClass("active");
            setTimeout(function () {
                jQuery("#" + hoverId).addClass("active");
            }, 400);
        } else {
            jQuery(".featured_list__item_image__inner .image").removeClass("active");
            setTimeout(function () {
                jQuery(".featured_list__item_image__inner .image.default").addClass("active");
            }, 400);
        }
    })

    testimonialShadow();

    jQuery(".nextSection").on("click", function () {
        if (jQuery(this).closest(".hero_banner").parent().next().length > 0) {
            var item = jQuery(this).closest(".hero_banner").parent().next();
            jQuery("body, html").animate({
                scrollTop: item.offset().top - 80
            }, 1000);
        }
    })
});

jQuery(".image_testimonial__content .testimonial_list .testimonial_scroll").on("scroll", function () {
    testimonialShadow();
});
jQuery(window).resize(function () {
    equalheight('.image_content_with_button_sec .title');
    equalheight('.image_content_with_button_sec .short_content');
    equalheight('.image_title_content_sec .title ');
    jQuery(".image_testimonial").each(function (index) {
        if (window.innerWidth < 992) {
            if (!jQuery('.testimonial_scroll__inner').hasClass('slick-initialized')) {
                let slide = jQuery(this).find('.testimonial_item');
                let slider = jQuery(this).find('.testimonial_scroll__inner');
                if (jQuery(slide).length > 1) {
                    jQuery(slider).slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        arrows: true,
                        dots: false,
                        prevArrow: jQuery('.prev-slide'),
                        nextArrow: jQuery('.next-slide'),
                    });
                }
            }
        } else {
            if (jQuery('.testimonial_scroll__inner').hasClass('slick-initialized')) {
                jQuery('.testimonial_scroll__inner').slick('unslick');
            }
        }
    });
});

function testimonialShadow() {
    if (jQuery(".image_testimonial__content .testimonial_list .testimonial_scroll").length > 0) {
        if ((jQuery(".image_testimonial__content .testimonial_list .testimonial_scroll").scrollTop() + jQuery(".image_testimonial__content .testimonial_list .testimonial_scroll").height()) > (jQuery(".image_testimonial__content .testimonial_list .testimonial_scroll .testimonial_scroll__inner").height() * 0.95)) {
            jQuery(".image_testimonial__content .testimonial_list").addClass("hide_shadow");
        } else {
            jQuery(".image_testimonial__content .testimonial_list").removeClass("hide_shadow");
        }
    }
}


function equalheight(container) {

    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;
    jQuery(container).each(function () {

        $el = jQuery(this);
        jQuery($el).height('auto')
        topPostion = $el.position().top;

        if (currentRowStart != topPostion) {
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
            rowDivs.length = 0; // empty the array
            currentRowStart = topPostion;
            currentTallest = $el.height();
            rowDivs.push($el);
        } else {
            rowDivs.push($el);
            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
        }
    });
}

function filterPlants(type) {
    var currentPostCount = jQuery(".plants_list__wrapper .plants_list > div").length;

    plants_admin_url = jQuery("#plants_admin_ajax_url").val();
    plants_per_page = jQuery("#plants_per_page").val();
    jsonObj = {
        "action": "filter_plants",
        "height": plants_height,
        "exposure": plants_exposure,
        "bloom_time": plants_bloom_time,
        "flower_color": plants_flower_color,
        "wildlife_interest": plants_wildlife_interest,
        "postperpage": parseInt(plants_per_page),
        "currentPostCount": currentPostCount,
        "paged": plants_paged,
        "type": type
    };

    jQuery.ajax({
        url: plants_admin_url,
        data: jsonObj, // form data
        type: "POST", // POST
        async: true,
        beforeSend: function (xhr) {
            console.log("ajax start"); // changing the button label
        },
        success: function (data) {
            // console.log(data.data);

            if (data.data.replace(/(\r\n\t|\n|\r\t)/gm, "").replace(" ", "") == "false" && type != 'loadmore') {
                // jQuery('.load_more_img').hide();
                jQuery(".plants_list__wrapper").html("<div class='no_found'>Result not found!!</div>");
                jQuery(".plants_list__wrapper").show();
                jQuery(".loadmore_button").hide();
                return false;
            } else if (type == 'loadmore') {
                // jQuery('.load_more_img').hide();
                jQuery(".plants_list__wrapper").show();
                jQuery(".plants_list__wrapper").html(data.data);
            } else {
                jQuery(".plants_list__wrapper").html("");
                jQuery(".plants_list__wrapper").html(data.data);
                // jQuery('.load_more_img').hide();
                jQuery(".plants_list__wrapper").show();
            }
        },
        error: function (xhr) {
            // jQuery('.load_more_img').hide();
            jQuery(".plants_list__wrapper").show();
            console.log(xhr);
        }
    });
}